import React, { memo, useState, useCallback } from 'react';
import { Icon, Tooltip, Popover, createUseStyles } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';

import ActionsMenu from './ActionsMenu';
import { useWeb5Context } from 'lib/Web5Context';

import styles from '../styles/index';

const useStyles = createUseStyles(styles, 'FieldSelectorMenuTrigger');

const FieldSelectorMenuTrigger = memo(
    ({ fieldSelectorProps, tooltipMenuContent = 'label_table_options_and_export', className }) => {
        const classes = useStyles();
        const { t } = useWeb5Context();
        const [visible, setVisible] = useState(false);

        const fieldSelectorClasses = classnames(
            classes.fieldSelectorIcon,
            {
                [classes.fieldSelectorIconActive]: visible,
            },
            'fm-grid__field-selector-icon',
        );

        const onToggleMenu = useCallback(() => setVisible((isVisible) => !isVisible), []);
        const onVisibleChange = useCallback((nextVisible) => setVisible(nextVisible), []);

        const content = (
            <div className={classes.fieldSelectorPopoverContent}>
                <ActionsMenu fieldSelectorProps={fieldSelectorProps} onToggleMenu={onToggleMenu} />
            </div>
        );

        return (
            <div className={className}>
                <Popover
                    placement="bottomLeft"
                    className={classes.fieldSelectorPopover}
                    content={content}
                    visible={visible}
                    onVisibleChange={onVisibleChange}
                >
                    <div onClick={onToggleMenu}>
                        <Tooltip placement="right" content={t(tooltipMenuContent)}>
                            <span className={fieldSelectorClasses}>
                                <Icon size="raw" name="moreHoriz" color="currentColor" />
                            </span>
                        </Tooltip>
                    </div>
                </Popover>
            </div>
        );
    },
);

export default FieldSelectorMenuTrigger;
